import Vue from 'vue'
import * as CoreStore from '@/app-core/api/datastore/Store.js'
import * as ThemeStore from '@/app-theme/api/datastore/Store.js'

const DataStore = Vue.observable({
  User: null,
  ...CoreStore,
  ...ThemeStore
})

export default DataStore
